interface ClosebtnProps {
  className?: string;
}

const Closebtn = (props: ClosebtnProps) => {
  return (
    <svg
      className={`${props.className ? props.className : ""}`}
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.698547 22.2815C1.18048 22.7632 1.79059 22.9881 2.40094 22.9881C3.01105 22.9881 3.65338 22.7632 4.10309 22.2815L11.4901 14.8946L18.877 22.2815C19.3587 22.7632 19.9691 22.9881 20.5794 22.9881C21.1895 22.9881 21.7999 22.7632 22.2816 22.2815C23.213 21.3501 23.213 19.8085 22.2816 18.877L14.8946 11.49L22.2816 4.10306C23.213 3.17166 23.213 1.63004 22.2816 0.698639C21.3502 -0.23288 19.8084 -0.23288 18.877 0.698639L11.4901 8.0856L4.10309 0.698639C3.17169 -0.23288 1.62994 -0.23288 0.698547 0.698639C-0.232849 1.63004 -0.232849 3.17166 0.698547 4.10306L8.08551 11.49L0.698547 18.877C-0.232849 19.8085 -0.232849 21.3501 0.698547 22.2815Z"
        fill="#E45555"
      />
    </svg>
  );
};

export default Closebtn;
